let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("12fs0")).then(() => parcelRequire('i0yfM'));